import { ChatModel } from '@/models/chat.model'
import { api } from '@/services/api'

export async function createGroup(chat: Partial<ChatModel>) {
  const response = await api.post('/mongo/groups', chat)
  return response.data
}

export async function addParticipants(chatId: string, phones: string[], ownerId: string) {
  const response = await api.patch(`/mongo/groups/${chatId}/participants`, { phones, ownerId })
  return response.data
}

export async function removeParticipant(chatId: string, participantPhone: string, ownerId: string) {
  const response = await api.delete(`/mongo/groups/${chatId}/participants/${participantPhone}`, {
    data: { ownerId }
  })
  return response.data
}

export async function exitGroup(chatId: string, campaignPhoneNumber: string, deleteToo: boolean, ownerId: string) {
  const response = await api.delete(`/mongo/groups/${chatId}/exit`, {
    data: { campaignPhoneNumber, deleteToo, ownerId }
  })
  return response.data
}

export async function updateGroup(
  chatId: string,
  data: Partial<Pick<ChatModel, 'chatName' | 'description' | 'requesterPhoto' | 'ownerId'>>
) {
  const response = await api.patch(`/mongo/groups/${chatId}`, data)
  return response.data
}

export async function promoteAdmin(chatId: string, participantPhone: string, ownerId: string) {
  const response = await api.patch(`/mongo/groups/${chatId}/admins/${participantPhone}/promote`, { ownerId })
  return response.data
}

export async function unpromoteAdmin(chatId: string, participantPhone: string, ownerId: string) {
  const response = await api.patch(`/mongo/groups/${chatId}/admins/${participantPhone}/unpromote`, { ownerId })
  return response.data
}
